import React from "react"
import { Trans } from "@lingui/macro"
import { Select } from "@silversea-ssc/ui-components-react"
import clsx from "clsx"
import { deepEqual } from "fast-equals"
import { GatewaySelectItem } from "../../../_common/read-models/gateway"
import styles from "./FarePriceFooter.module.scss"

type OnChangeGateway = (gatewayCode: string) => void

type Props = {
    gateways: GatewaySelectItem[]
    value?: string
    onChange?: OnChangeGateway
}

const GatewaySelect: React.FC<React.PropsWithChildren<Props>> = ({ gateways, value, onChange }) => {
    return (
        <React.Fragment>
            <div className={styles.actionLabel}>
                <Trans id="gateway-select-label">gateway</Trans>
            </div>
            <Select
                variant="white"
                className={clsx(styles.gatewaySelect)}
                // eslint-disable-next-line react/jsx-no-bind
                onChange={(e) => onChange?.(e.target.value)}
                value={value}
                dataContentPiece="gateway_select"
            >
                {gateways.map(({ code, label }) => (
                    <option key={code} value={code}>
                        {label}
                    </option>
                ))}
            </Select>
        </React.Fragment>
    )
}

export default React.memo(GatewaySelect, deepEqual)
